import { PackageDto } from "../../redux/homepage/type";

export const PackageField = (data: PackageDto, t: any) => [
  {
    field: t.getString("Asset Limit"),
    value: data.AssetLimit,
    isText: true,
  },
  {
    field: t.getString("User Limit"),
    value: data.UserLimit,
    isText: true,
  },
  {
    field: t.getString("Storage Limit"),
    value: data.StorageLimit,
    isText: true,
  },
  {
    field: t.getString("Location Limit"),
    value: data.Location,
    isText: true,
  },
  {
    field: t.getString("Tariff Manangement"),
    value: data.Management,
  },
  {
    field: t.getString("Maintenances"),
    value: data.Maintenance,
  },
  {
    field: t.getString("Expenses"),
    value: data.Expenses,
  },
  {
    field: t.getString("Financial Accounts"),
    value: data.FinancialAccounts,
  },

  {
    field: t.getString("Extra Services"),
    value: data.ExtraServices,
  },
  {
    field: t.getString("Suppliers"),
    value: data.Suppliers,
  },
  {
    field: t.getString("Insurances"),
    value: data.Insurances,
  },
  {
    field: t.getString("APIIO"),
    value: data.APIIO,
  },
  {
    field: t.getString("Web Site"),
    value: data.WebSite,
  },
  {
    field: t.getString("Mobile App"),
    value: data.MobileApp,
  },
];
